import { useQuery, useQueryClient } from 'react-query';
import * as teamsApi from 'resources/teams/teams.api';

export default function useGetTeams() {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData(['user.currentUser']);

  return useQuery(
    ['teams.get-teams', currentUser.company_id],
    () => teamsApi.getTeams(),
  );
}
